//@ts-nocheck

import MyAlert from '../../helpers/myAlert';

export default () => {
  $('.tt-homepage-newsletter-v3__form').on('submit', function (e) {
    e.preventDefault();
    const form = $(this);
    const lang = $(this).data('lang');

    const checked = $('#tt-homepage-newsletter-v3-checkbox-input').prop(
      'checked'
    );
    if (!checked) {
      const props = {
        message:
          lang == 'de'
            ? 'Das Kontrollkästchen darf nicht leer bleiben!'
            : 'The checkbox cannot be left blank!',
      };
      MyAlert(props);

      return false;
    }

    const fullName = $('#tt-homepage-newsletter-v3__form-fullname').val();
    const email = $('#tt-homepage-newsletter-v3__form-email').val();
    if (fullName.length == 0 || email.length == 0) {
      const props = {
        message:
          lang == 'de'
            ? 'Bitte füllen Sie alle Felder aus'
            : 'Please fill in all fields',
      };
      MyAlert(props);

      return false;
    }

    const obj = new Object();
    obj.name = fullName;
    obj.mail = email;
    obj.firma = '';

    $.ajax({
      url: '/ui/Newsletter@FooterPost',
      type: 'post',
      data: obj,
      async: false,
      success: async function (data) {
        form.css('opacity', 0);
        await waitForMs(150);
        form.hide();
        $('.tt-homepage-newsletter-v3__form-result').css('display', 'flex');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(JSON.stringify(jqXHR));
      },
    });
  });

  $('.tt-homepage-newsletter-v3__form-result-button').on('click', function () {
    $('.tt-homepage-newsletter-v3__form-result').hide();
    $('.tt-homepage-newsletter-v3__form').css('opacity', 1).show();
  });
};
